<div class="credit-meter" [attr.data-state]="noticeLabel ? 'notice' : state">
  @if (noticeLabel) {
  <span class="credit-meter__headline">{{ noticeLabel }}</span>
  <button type="button" class="credit-meter__upgrade" (click)="onUpgrade()">Upgrade plan</button>
  } @else if (state === 'no-plan') {
  <span class="credit-meter__headline">No active plan</span>
  <button type="button" class="credit-meter__upgrade" (click)="onUpgrade()">Upgrade plan</button>
  } @else {
  <div class="credit-meter__row">
    <span class="credit-meter__used">{{ usedLabel }} used</span>
    <span class="credit-meter__headline">{{ remainingLabel }} credits left</span>
  </div>
  <div
    class="credit-meter__track"
    role="progressbar"
    aria-valuemin="0"
    aria-valuemax="100"
    [attr.aria-valuenow]="fillPercentValue"
    [attr.aria-label]="usedLabel + ' used, ' + remainingLabel + ' credits left'"
  >
    <div class="credit-meter__fill" [style.width]="fillPercent"></div>
  </div>
  @if (resetDate) {
  <span class="credit-meter__reset">Resets {{ resetDate | date: 'MMM d' : 'UTC' }}</span>
  } @if (reserveNote) {
  <span class="credit-meter__reserve">{{ reserveNote }}</span>
  } @if (walletNote) {
  <span class="credit-meter__wallet">
    {{ walletNote }} @if (walletNoteDetail) {
    <button
      type="button"
      class="credit-meter__info"
      [attr.aria-label]="walletNoteDetail"
      [attr.data-tooltip]="walletNoteDetail"
    >
      i
    </button>
    }
  </span>
  } @if (state === 'exhausted') {
  <button type="button" class="credit-meter__upgrade" (click)="onUpgrade()">Upgrade plan</button>
  } }
</div>
